import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'filterBy' })
export class FilterByPipe implements PipeTransform {
  transform<T>(items: T[] = [], prop: keyof T, allowed: any[] = []): T[] {
    if (!items.length || !prop || !allowed.length) {
      return items;
    }
    return items.filter(item => allowed.includes(item[prop]));
  }
}
